module.exports = __webpack_public_path__ + "static/media/communaute_decolorStop_desktop.f707ca0c.jpg";